/**
 * 📏 FIELD LIMITS CONSTANTS - UI field limits aligned with security constants

 * Used across the entire application for consistent field length limits.
 */

// Character limits for all application fields (aligned with fieldValidation.constants.ts)
export const NAME_CHAR_LIMIT = 50;
export const DESCRIPTION_CHAR_LIMIT = 200;
export const USERNAME_CHAR_LIMIT = 30;
export const EMAIL_CHAR_LIMIT = 254;
export const TEXT_CHAR_LIMIT = 100;
export const PASSWORD_CHAR_LIMIT = 100;
export const TOURNAMENT_PASSWORD_CHAR_LIMIT = 50;
export const TOURNAMENT_NAME_CHAR_LIMIT = 30;

// Character count warning thresholds (when to show orange warning)
export const CHARACTER_WARNING_THRESHOLD = 0.8; // 80%

/**
 * 📊 FIELD LIMIT MAP - Easy lookup for any field type
 *
 * Use this to get character limits consistently across the app:
 * const limit = FIELD_LIMITS.name; // 50
 */
export const FIELD_LIMITS = {
  name: NAME_CHAR_LIMIT,
  description: DESCRIPTION_CHAR_LIMIT,
  tournament_password: TOURNAMENT_PASSWORD_CHAR_LIMIT,
  username: USERNAME_CHAR_LIMIT,
  tournament_name: TOURNAMENT_NAME_CHAR_LIMIT,
  email: EMAIL_CHAR_LIMIT,
  text: TEXT_CHAR_LIMIT,
  password: PASSWORD_CHAR_LIMIT,
} as const;

/**
 * 🎯 FIELD TYPE MAP - Maps field types to their limits
 *
 * Useful for programmatic access:
 * const getLimit = (fieldType: string) => FIELD_TYPE_LIMITS[fieldType] || TEXT_CHAR_LIMIT;
 */
export type FieldType = keyof typeof FIELD_LIMITS;
export const FIELD_TYPE_LIMITS: Record<string, number> = FIELD_LIMITS;
